document.addEventListener("DOMContentLoaded", function() {
  const loader = document.getElementById("templazee-loader");
  const loadingTime = parseInt(loader.getAttribute('data-load'), 10) || 3;
  const loaderTimeInMs = loadingTime * 1000;

  document.body.style.visibility = 'hidden';

  if (loader) {
    loader.classList.add('active');
    
    setTimeout(() => {
      loader.classList.remove('active');
      document.body.style.visibility = 'visible';
    }, loaderTimeInMs);
  }
});